import React from 'react';
import { TalentBios, useApi } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { CandidateApi } from '../../api/candidate-api';
import { TaxonomyApi } from '../../api/taxonomy-api';
import { EnvUtil } from '../../utils/env-util';

export const BioPdfDownloadItem = ({
  name = 'BIO_PDF_DOWNLOAD_ITEM',
  candidateId,
  isAnonymous,
  hideAllHighlights = false,
  hideLocation = false,
  onSave,
}: {
  name?: string;
  candidateId: Candidate['id'];
  isAnonymous: boolean;
  hideAllHighlights?: boolean;
  hideLocation?: boolean;
  onSave: () => void;
}) => {
  const [{ data: bioCandidate }, { data: taxonomy }] = useApi(
    CandidateApi.readBio({ candidateId, isAnonymous }),
    TaxonomyApi.readTaxonomy()
  );

  return (
    <TalentBios
      name={name}
      isAhqBio
      isDownloading
      onSave={onSave}
      candidate={bioCandidate}
      groupedExperiences={bioCandidate.groupedExperiences}
      legalTechSkills={bioCandidate.legalTechSkills}
      clientUrl={EnvUtil.clientUrl}
      taxonomy={taxonomy}
      isAnonymous={isAnonymous}
      hideAllHighlights={hideAllHighlights}
      hideLocation={hideLocation}
    />
  );
};
